import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import FilterItems from './Components/ModelFilters/FilterItems'
import FilterPanel from './Components/ModelFilters/FilterPanel'
import PromoCards from './Components/ModelFilters/PromoCards'

function ModelFilterSection({ byFormat, byType, freeItems = '', locale = 'en' }) {
  const filterByTypeTitle = i18n.t('modelFilters.filterByType.title', { ns: 'new-home', lng: locale })
  const filterByTypeDescription = i18n.t('modelFilters.filterByType.description', { ns: 'new-home', lng: locale })

  const filterByFormatTitle = i18n.t('modelFilters.filterByFormat.title', { ns: 'new-home', lng: locale })
  const filterByFormatDescription = i18n.t('modelFilters.filterByFormat.description', { ns: 'new-home', lng: locale })

  return (
    <div className="model-filter new-home-section">
      <div className="model-filter__layout">
        <div className="model-filter__type-section">
          <FilterPanel
            heading={filterByTypeTitle}
            description={filterByTypeDescription}
          >
            <FilterItems items={byType} type="types" isLink />
          </FilterPanel>
        </div>

        <div className="model-filter__format-section">
          <FilterPanel
            heading={filterByFormatTitle}
            description={filterByFormatDescription}
          >
            <FilterItems items={byFormat} type="formats" isLink showMeta />
          </FilterPanel>
        </div>

        <div className="model-filter__promo-section">
          <PromoCards freeItems={freeItems} locale={locale} />
        </div>
      </div>
    </div>
  )
}

ModelFilterSection.displayName = 'ModelFilterSection'

const AssetPropType = shape({
  name: string.isRequired,
  count: string,
  extensions: string,
  icon: string,
  path: string.isRequired,
})

ModelFilterSection.propTypes = {
  byFormat: arrayOf(AssetPropType).isRequired,
  byType: arrayOf(AssetPropType).isRequired,
  locale: string,
  freeItems: string,
}

export default ModelFilterSection
